import React from 'react';
import {connect} from 'react-redux';
import ListSinglePerson from './ListSinglePerson.jsx';
import { TextMessage } from 'components/tt-forms/common';

class ThongTinNguoiDungDon extends React.Component {

  render() {
    return (
      <div className="box-items">
        <div className="box-forward">

            <div className="title">
              <div className="rows">
                <div className="col-12">
                  <h3 className="mb15">{this.props.title}</h3>
                </div>
              </div>
            </div>

            <div className="group-box">
              <div className="items-form mb10">
                <div className="rows">
                  <TextMessage className="col-input" label="Loại đối tượng:" value={this.props.parent.data.loaiNguoiDungDonInfo ? this.props.parent.data.loaiNguoiDungDonInfo.ten : ''} />

                  {this.props.parent.data.loaiNguoiDungDon == "CO_QUAN_TO_CHUC" ? (
                    <div>
                      <TextMessage className="col-input" label="Tên cơ quan/Tổ chức:" value={this.props.parent.data.listNguoiDungDon ? this.props.parent.data.listNguoiDungDon[0].tenCoQuan : ''} />
                      <TextMessage className="col-input" label="Địa chỉ cơ quan:" value={this.props.parent.data.listNguoiDungDon ? this.props.parent.data.listNguoiDungDon[0].diaChiCoQuan : ''} />
                      <TextMessage className="col-input" label="Điện thoại cơ quan:" value={this.props.parent.data.listNguoiDungDon ? this.props.parent.data.listNguoiDungDon[0].soDienThoaiCoQuan : ''} />
                    </div>
                  ):null}
                  {this.props.parent.data.loaiNguoiDungDon == "DOAN_DONG_NGUOI" ? (
                    <div>
                      <TextMessage className="col-input" label="Số người:" value={this.props.parent.data ? String(this.props.parent.data.soNguoi) : ''} />
                      <TextMessage className="col-input" label="Số người đại diện:" value={String(this.props.parent.data.listNguoiDungDon.length)} />
                    </div>
                  ):null}
                </div>
              </div>
              <div className="pl5 pr5 mb15"><div className="line-border"></div></div>
            </div>
            <ListSinglePerson parent={this.props.parent}/>

        </div>
      </div>
    );
  }
}

function bindStateToProp(state) {
  return {}
}

export default connect(bindStateToProp)(ThongTinNguoiDungDon)


// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/ThongTinNguoiDungDon.jsx